import NotFound from "../../msg/NotFound";
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from "react-icons/ai";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useState } from "react";

function BrandList({ brands, onRemove, onEdit, onView }) {
    const [openMenu, setOpenMenu] = useState(null);

    if (brands.length === 0) {
        return <NotFound text="هنوز برندی ثبت نشده است." />;
    }

    const langLabel = (lang) => {
        if (lang === "fa") return "فارسی";
        if (lang === "en") return "English";
        return lang || "—";
    };

    const toggleMenu = (id) => {
        setOpenMenu(openMenu === id ? null : id);
    };

    const handleView = (brand) => {
        setOpenMenu(null);
        if (onView) onView(brand);
    };

    const handleEdit = (brand) => {
        setOpenMenu(null);
        if (onEdit) onEdit(brand);
    };

    const handleDelete = (brand) => {
        onRemove(brand);
        setOpenMenu(null);
    };

    return (
        <div className="bg-gray-50 rounded-xl border border-gray-200">
            <div className="grid grid-cols-12 gap-2 bg-gray-100 px-4 py-3 text-gray-700 text-sm font-bold rounded-t-xl rtol">
                <div className="col-span-2">نام برند</div>
                <div className="col-span-3">دامنه</div>
                <div className="col-span-2">وضعیت</div>
                <div className="col-span-1">زبان</div>
                <div className="col-span-2">Policy</div>
                <div className="col-span-1">تاریخ ایجاد</div>
                <div className="col-span-1 text-left">عملیات</div>
            </div>
            {brands.map((b) => (
                <div
                    key={b.id}
                    className="grid grid-cols-12 gap-2 px-4 py-3 border-t border-gray-200 text-sm items-center rtol"
                >
                    <div className="col-span-2 font-bold text-gray-800">{b.name}</div>
                    <div className="col-span-3 text-gray-600">{b.domain || "—"}</div>
                    <div className="col-span-2">
                        <span
                            className={
                                "px-4 py-1 rounded-lg text-xs font-bold " +
                                (b.isActive
                                    ? "bg-green-50 text-green-600 border border-green-200"
                                    : "bg-red-50 text-redCustom-500")
                            }
                        >
                            {b.isActive ? "فعال" : "غیرفعال"}
                        </span>
                    </div>
                    <div className="col-span-1 text-gray-600">{langLabel(b.language)}</div>
                    <div className="col-span-2 text-gray-600">
                        <div className="flex flex-col">
                            <div dir="rtl" className="flex items-center gap-2">
                                {b.accessOwnBrand ? (
                                    <AiOutlineCheckCircle className="text-green-600 text-lg" />
                                ) : (
                                    <AiOutlineCloseCircle className="text-red-600 text-lg" />
                                )}
                                <span className="text-xs">دسترسی برند خود</span>
                            </div>
                            <div className="flex items-center gap-2">
                                {b.accessOtherBrands ? (
                                    <AiOutlineCheckCircle className="text-green-600 text-lg" />
                                ) : (
                                    <AiOutlineCloseCircle className="text-red-600 text-lg" />
                                )}
                                <span className="text-xs">دسترسی برند دیگر</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-1 text-gray-600">{b.createdAt || "—"}</div>
                    <div className="flex justify-end relative">
                        <button
                            type="button"
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleMenu(b.id);
                            }}
                            className="p-2 rounded-lg hover:bg-gray-100 text-gray-600"
                        >
                            <BsThreeDotsVertical />
                        </button>
                        {openMenu === b.id && (
                            <div className="absolute left-6 top-2 mt-1 w-32 bg-white border border-gray-200 rounded-lg shadow-lg z-20">
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleView(b);
                                    }}
                                    className="w-full text-right px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                                >
                                    مشاهده
                                </button>
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleEdit(b);
                                    }}
                                    className="w-full text-right px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                                >
                                    ویرایش
                                </button>
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDelete(b);
                                    }}
                                    className="w-full text-right px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
                                >
                                    حذف
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default BrandList;
